export default defineNuxtPlugin(async () => {
  const { getShield } = useShield()
  await getShield()
})
